import { CurrencyInitializationService } from '../services/currencyInitializationService';

/**
 * Global function to initialize currency service
 * @param {Object} props - Configuration props from server
 * @returns {Promise<boolean>} Whether initialization completed successfully
 */
window.initializeCurrencyService = async (props) => {
  try {
    const service = new CurrencyInitializationService();
    service.initialize(props);
    
    const success = await service.execute();
    
    // Store service instance for manual operations if needed
    window.currencyInitializationService = service;
    
    return success;
  } catch (error) {
    console.error('[CurrencyInitialization] Service initialization failed:', error);
    return false;
  }
};
